import { render } from "./SystemLogsList.vue?vue&type=template&id=09806cb7&scoped=true&ts=true"
import script from "./SystemLogsList.vue?vue&type=script&lang=ts"
export * from "./SystemLogsList.vue?vue&type=script&lang=ts"

import "./SystemLogsList.vue?vue&type=style&index=0&id=09806cb7&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09806cb7"]])

export default __exports__